
/**
 * Change date format.
 * @param {number} val Date value
 * @param {string} f Date format
 */
import tippy from 'tippy.js'

export default function truncate(text, length = 10, clamp = 'more...') {
	if (!text) return

	let content = text.split(' ')
	if (content.length > length) {
		const ext = `<a class="truncate-more" aria-label="${text}">${clamp}</a>`

		setTimeout(() => {
			tippy(document.querySelector('.truncate-more'), {
				theme: 'title',
				placement: 'top',
				maxWidth: '250px',
				touch: false,
				content(ref) {
					const title = ref.getAttribute('aria-label')
					ref.removeAttribute('aria-label')
					return title
				},
				onShow(instance) {
					if (!instance.props?.content?.length) return false
					return instance
				}
			})
		}, 1500)

		return [...content.slice(0, length), ext].join(' ')
	}
	return text
}
